import React from 'react';
import { translate } from 'react-i18next';
import './footer.css';
import { Link } from "react-router-dom";



class Footer extends React.Component {
    goToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "initial"
        });
    }
    render() {

        const { t } = this.props;
        var path = window.location.pathname
        var match = path.slice(0, 3);
        return (
            <footer>
                <div className="container-fluid">
                    <div className="d-flex">
                        <div className="col-lg-1"></div>
                        <div className="footer-sections col-12 col-lg-10 d-lg-flex">
                            <div className="footer-section-1 col-lg-3">
                                <div className="d-flex d-lg-block">
                                    <div className="footer-text col-6 col-lg-12">
                                        <Link to={match + "/about"} onClick={() => this.goToTop()}>{t('About')}</Link>
                                    </div>
                                    <div className="footer-text col-6 col-lg-12">
                                        <Link to={match + "/conference"} onClick={() => this.goToTop()}>{t('Conference')}</Link>
                                    </div>
                                </div>
                                <div className="d-flex d-lg-block">
                                    <div className="footer-text col-6 col-lg-12">
                                        <Link to={match + "/competition"} onClick={() => this.goToTop()}>{t('Competition')}</Link>
                                    </div>
                                    <div className="footer-text col-6 col-lg-12">
                                        <Link to={match + "/awardsceremony"} onClick={() => this.goToTop()}>{t('Awards Ceremony')}</Link>
                                    </div>
                                </div>
                                <div className="d-flex d-lg-block">
                                    <div className="footer-text col-6 col-lg-12">
                                        <Link to={match + "/E&MAILab/about"} onClick={() => this.goToTop()}>{t('E&M AI Lab')}</Link>
                                    </div>
                                    <div className="footer-text col-6 col-lg-12">
                                        <Link to={match + "/acknowledgements"} onClick={() => this.goToTop()}>{t('Acknowledgements')}</Link>
                                    </div>
                                </div>
                                <div className="d-flex d-lg-block">
                                    <div className="footer-text col-6 col-lg-12">
                                        <Link to={match + "/sponsors"} onClick={() => this.goToTop()}>{t('Sponsors')}</Link>
                                    </div>
                                    <div className="footer-text col-6 col-lg-12">
                                        <Link to={match + "/gallery"} onClick={() => this.goToTop()}>{t('Gallery')}</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="footer-section-2 col-lg-5">
                                <div className={t('footer-section-headline TXT_bold')}>
                                    <span>{t('Support')}</span>
                                </div>
                                <div className="d-flex d-lg-block">
                                    <div className="footer-text col-6 col-lg-12">
                                        <Link to={match + "/faq"} onClick={() => this.goToTop()}>{t('FAQ')}</Link>
                                    </div>
                                    <div className="footer-text col-6 col-lg-12">
                                        <Link to={match + "/terms"} onClick={() => this.goToTop()}>{t('Terms & Conditions')}</Link>
                                    </div>
                                </div>
                                <div className="d-flex d-lg-block">
                                    <div className="footer-text col-6 col-lg-12">
                                        <Link to={match + "/privacy"} onClick={() => this.goToTop()}>{t('Privacy Policy')}</Link>
                                    </div>
                                    <div className="footer-text col-6 col-lg-12">
                                        <Link to={match + "/personal"} onClick={() => this.goToTop()}>{t('Personal Information Collection Statement')}</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="footer-section-3 col-lg-4 text-end">
                                <div className={t('footer-section-headline TXT_bold')}>
                                    <span>{t('Contact Us')}</span>
                                </div>
                                <div className="footer-text">
                                    <a href="mailto:info@globalaichallenge.com" >info@globalaichallenge.com</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-1"></div>
                    </div>
                    <div className="copyright align-self-end text-center py-2">{t('copyright')}</div>
                </div>
            </footer >
        );
    };

};

export default translate("translations")(Footer);



// WEBPACK FOOTER //
// ./src/components/layout/footer.js